// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import type {} from '../types';

// ---------------------------------------------------------------
// Mutation Keys
// ---------------------------------------------------------------
export const postStartTrialMutationKey = ['postStartTrial'] as const;
export const postFinishTrialMutationKey = ['postFinishTrial'] as const;

// ---------------------------------------------------------------
// Query Keys
// ---------------------------------------------------------------
